import { CpqNumberOptions } from "../../directives/validator/cpq-number-options.model";

export class CpqNumberOptionsBuilder {
    private readonly numberOptions: CpqNumberOptions;

    constructor() {
        this.numberOptions = new CpqNumberOptions();
    }

    allowZero(): CpqNumberOptionsBuilder {
        this.numberOptions.includeMinValue = true;
        return this;
    }

    disallowZero(): CpqNumberOptionsBuilder {
        this.numberOptions.includeMinValue = false;
        return this;
    }

    allowDecimal(): CpqNumberOptionsBuilder {
        this.numberOptions.allowDecimal = true;
        return this;
    }

    disallowDecimal(): CpqNumberOptionsBuilder {
        this.numberOptions.allowDecimal = false;
        return this;
    }

    allowOnlyPositiveNumbers(): CpqNumberOptionsBuilder {
        this.numberOptions.minValue = 0;
        return this;
    }

    build(): CpqNumberOptions {
        return this.numberOptions;
    }
}